import { render, staticRenderFns } from "./todoWorkApprove.vue?vue&type=template&id=38f97556&scoped=true"
import script from "./todoWorkApprove.vue?vue&type=script&lang=js"
export * from "./todoWorkApprove.vue?vue&type=script&lang=js"
import style0 from "./todoWorkApprove.vue?vue&type=style&index=0&id=38f97556&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f97556",
  null
  
)

export default component.exports